import React from "react"
import ReactDOM from "react-dom"
import reportWebVitals from "./reportWebVitals";
import App from "./App.js"


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <App />
);

reportWebVitals();
